import type { TFilterItem, TFilterItemRange } from '../data/types'
import type { TConfigMeta } from '~/layers/meta/types/meta.types'

import { useCatalogGridStore } from '../store/catalogGrid'

export default function useMetaJewelry(type: CatalogDataProviderType, configData?: TConfigMeta) {
  const gridStore = useCatalogGridStore()
  const priceFilter = gridStore.filters.find((filter) => filter.code == 'price') as TFilterItemRange & TFilterItem

  const breadCrumbsJewelry = computed(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Главная',
          item: {
            '@type': 'Thing',
            '@id': 'https://alrosadiamond.ru/',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Ювелирные украшения',
          item: {
            '@type': 'Thing',
            '@id': 'https://alrosadiamond.ru/jewelry/',
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: gridStore.pageTitle,
        },
      ],
    }
  })

  const breadCrumbsDiamonds = computed(() => {
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Главная',
          item: {
            '@type': 'Thing',
            '@id': 'https://alrosadiamond.ru/',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Бриллианты',
        },
      ],
    }
  })

  const jewelryStoreConfig = computed(() => {
    const jewelryStore: Record<string, string> = {
      '@context': 'https://schema.org',
      '@type': 'JewelryStore',
    }
    tryAddProperty(jewelryStore, 'name', configData?.microdata_jewelry_store_name_ru)
    tryAddProperty(jewelryStore, 'description', configData?.microdata_jewelry_store_description_ru)
    tryAddProperty(jewelryStore, 'priceRange', configData?.microdata_jewelry_store_price_ru)
    tryAddProperty(jewelryStore, 'telephone', configData?.microdata_jewelry_store_tel_ru)
    tryAddProperty(jewelryStore, 'image', configData?.microdata_jewelry_store_logo_ru)

    const address: Record<string, string> = {
      '@type': 'PostalAddress',
    }
    tryAddProperty(address, 'addressLocality', configData?.microdata_jewelry_store_addr_loc_ru)
    tryAddProperty(address, 'streetAddress', configData?.microdata_jewelry_store_addr_street_ru)
    tryAddProperty(address, 'email', configData?.microdata_jewelry_store_addr_email_ru)

    return {
      ...jewelryStore,
      address,
    }
  })

  const productConfig = computed(() => {
    const product: Record<string, string | object> = {
      '@context': 'https://schema.org',
      '@type': 'Product',
    }
    tryAddProperty(product, 'name', gridStore.pageTitle)
    tryAddProperty(product, 'image', configData?.microdata_product_diamondimg_ru)

    const brand: Record<string, string> = {
      '@type': 'Brand',
    }
    tryAddProperty(brand, 'name', configData?.microdata_blog_author_ru)

    const offers: Record<string, string> = {
      '@type': 'AggregateOffer',
    }
    tryAddProperty(offers, 'priceCurrency', configData?.microdata_jewelry_store_currency_ru)
    tryAddProperty(offers, 'lowPrice', priceFilter?.range.from?.toString())
    tryAddProperty(offers, 'highPrice', priceFilter?.range.to?.toString())
    tryAddProperty(offers, 'offerCount', gridStore.navigation.total.toString())

    return {
      ...product,
      brand,
      offers,
    }
  })

  return {
    script: [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(type == 'diamonds' ? breadCrumbsDiamonds.value : breadCrumbsJewelry.value),
      },
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(jewelryStoreConfig.value),
      },
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(productConfig.value),
      },
    ],
  }
}
